<template>
  <e-charts :options="option"/>
</template>
<script>
import ECharts from 'vue-echarts'
const setColor = (color) => (
  {
    // 点的颜色
    itemStyle: {
      color
    },
    // 区域颜色
    // areaStyle: {
    //   color
    // },
    // 线条颜色
    lineStyle: {
      color
    }
  }
)
export default {
  name: 'EChartLine',
  components: {
    ECharts
  },
  data () {
    return {
      option: {
        tooltip: {},
        legend: {
          top: 10,
          textStyle: {
            color: '#fff'
          },
          data: ['入网企业', '生码商品', '查询次数', '查询率']
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['2012', '2013', '2014', '2015', '2016', '2017', '2018'],
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            // offset: -10,
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              formatter: value => {
                return `${value / 10000}万`
              },
              // inside: true
              padding: [0, -7, 0, 0]
            }
          },
          {
            type: 'value',
            max: 10,
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
          }
        ],
        series: [
          {
            name: '入网企业',
            type: 'line',
            smooth: true,
            data: [8312, 10267, 20982, 25635, 38257, 43672, 50215],
            ...setColor('#fd8b04')
          },
          {
            name: '生码商品',
            type: 'line',
            smooth: true,
            data: [845.301, 1311.227, 2131.235, 2981.326, 3941.138, 4424.976, 5233.098],
            ...setColor('#3bcafc')
          },
          {
            name: '查询次数',
            type: 'line',
            smooth: true,
            data: [11271, 37829, 41832, 49245, 57823, 110783, 129832],
            ...setColor('#ff242a')
          },
          {
            name: '查询率',
            yAxisIndex: 1,
            type: 'line',
            smooth: true,
            data: [1.3333712, 2.8850077, 1.9628056, 1.6517818, 1.4671651, 2.5035842, 2.4809778],
            ...setColor('#a95be6')
          }
        ]
      }
    }
  }
}
</script>
